var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"img-verify"},[_c('canvas',{ref:"verify",attrs:{"width":_vm.width,"height":_vm.height},on:{"click":_vm.handleDraw}})])}
var staticRenderFns = []

export { render, staticRenderFns }